<template>
  <div id="ag-grid-demo">
    <!-- START FILTER BLOCK -->
    <div class="vx-col w-full mb-base">
      <div class="filter_container">
        <vx-card title="Sélection du client" class="filter_card mr-4">
          <p>
            Sélectionner le client pour lequel vous souhaitez voir les
            statisques
          </p>
          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <vs-select
                autocomplete
                v-model="society"
                class="w-full select-large mt-4"
                label="Choisissez un client"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item.name"
                  v-for="(item, index) in allSocieties"
                  class="w-full"
                />
              </vs-select>
              <vs-button color="primary" class="mt-4" v-if="explorationData" @click="updateData"
                >Actualiser les données</vs-button
              >
              <div class="mt-4" v-if="explorationData">
                <span
                  >L'actualisation des données est un procéssus qui prend
                  plusieurs minutes.</span
                >
              </div>
            </div>
          </div>
        </vx-card>

        <vx-card title="Informations complémentaire">
          <p>Indiquez une de ces informations pour explorer votre site</p>

          <div class="vx-row">
            <div class="vx-col w-1/2">
              <vs-input
                class="w-full"
                label-placeholder="Url du robot.txt"
                v-model="robotxt_url"
              />
              <div class="mt-4">
                <vs-button color="primary" class="float-left">Explorer</vs-button>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <!-- END FILTER BLOCK -->

    <div class="center_vertical" v-if="taskIsReady == false">
      <span class="txt_center"
        >Le chargement de vos données peut prendre plusieurs minutes.</span
      >
      <span class="txt_center"
        >Vous serez informé par mail lorsque celles-ci seront prêtes.</span
      >
    </div>

    <div v-if="explorationData">
      <div class="vx-row">
        <div class="vx-col flex-1">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="UserIcon"
            :statistic="explorationSummary.summary[0]['response_code_3xx']"
            statisticTitle="Pages en redirection 301, 302"
            color="warning"
          />
        </div>

        <div class="vx-col flex-1">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="SmileIcon"
            :statistic="explorationSummary.summary[0]['response_code_4xx']"
            statisticTitle="Page(s) en erreur 404"
            color="danger"
          />
        </div>

        <div class="vx-col flex-1">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="SmileIcon"
            :statistic="explorationSummary.summary[0]['response_code_5xx']"
            statisticTitle="Page(s) en erreur 500"
            color="danger"
          />
        </div>
      </div>

      <div class="vs-row">
        <ExplorationTable
          v-if="explorationData.pages"
          :explorationData="explorationData.pages"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import {Society} from "@/entities/Society";
import StatisticsCardLine from "@/components/views/dashboard/statistics-cards/StatisticsCardLine.vue";
import ExplorationTable from "@/components/tables/ExplorationTable.vue";
import store from "@/store/store";
import VueCookies from "vue-cookies";

export default {
	name: "ExplorationStatistics",
	components: {
		StatisticsCardLine,
		ExplorationTable
	},
	data() {
		return {
			currentUser: VueCookies.get("userInfo"),

			hasFilter: false,
			loaded: false,
			loadingPercent: 0,
			society: null,
			societyUrls: null,
			robotxt_url: null,
			apiUrl: this.$store.state.backendApiUrl,
			explorationImageData: null,
			explorationSummary: null,
			currentTaskId: null,
			taskIsReady: null,
			// PROPS
			explorationData: null
		};
	},

	created() {
		//console.log("created");
		this.loaded = false;
		// Reset data
		this.taskIsReady = null;
		this.explorationData = null;
		// Update the last society item
		if(this.selectedSociety["dataforseo_id"]) {
			this.openLoading();
			this.getTaskStatus(this.selectedSociety["dataforseo_id"]);
		}
		else{
			this.setNewTask(this.selectedSociety);
		}
		sessionStorage.setItem("lastSociety", this.selectedSociety.id);
	},
	computed: {
		allSocieties: () => {
			return store.state.societies;
		},
		selectedSociety(){
			return this.$store.state.activeUserSociety;
		},
	},
	watch: {
		selectedSociety: function(data) {
			// Reset data
			this.taskIsReady = null;
			this.explorationData = null;
			// Update the last society item
			if(data["dataforseo_id"]) {
				this.openLoading();
				this.getTaskStatus(data["dataforseo_id"]);
			}
			else{
				this.setNewTask(data);
			}
			sessionStorage.setItem("lastSociety", data.id);
		},

		currentTaskId: function(data) {
			//console.log("current taksid changed");
			this.getTaskStatus(data);
		}
	},
	methods: {
		/**
		 * Starts a spinning loader
		 */
		openLoading() {
			this.$vs.loading();
			setTimeout(() => this.$vs.loading.close(), 2000);
		},

		/**
		 * Fetch all society
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},

		/**
		 * Query API to start a new task for a society (ON PAGE API)
		 * @param {object} society - Society object
		 */
		setNewTask(society) {
			//console.log("setNewTask");
			this.$http
				.post(this.apiUrl + "dataforseo/newtask", {
					society: society
				})
				.then(res => (this.taskIsReady = false))
				.catch(err => console.error(err));
		},

		/**
		 * Set null exploration data and query API to start a new task (ON PAGE API)
		 */
		updateData() {
			// Reset data
			this.explorationData = null;
			this.setNewTask(this.selectedSociety);
		},

		/**
		 * Query the API to fetch all the url of a domain
		 * @param {object} society - Society object
		 */
		getSitemap(society) {
			//console.log("getSitemap");
			this.$http
				.post(this.apiUrl + "webmaster/sitemaps", {
					url: society.gsc_url
				})
				.then(res => (this.societyUrls = res.data.data))
				.catch(err => console.error(err));
		},

		/**
		 * Query API to get the current status of the task
		 * @param {number} taskId - ID of a task
		 */
		getTaskStatus(taskId) {
			//console.log("getTaskStatus");
			this.$http
				.post(this.apiUrl + "dataforseo/task/status", {
					taskId: taskId
				})
				.then(res => {
					let taskStatus = res.data.data.results[0].status;
					if(taskStatus == "crawled") {
						this.taskIsReady = true;
						this.explorationSummary = res.data.data.results[0];
						this.getPages(taskId);
					}
					else{
						this.taskIsReady = false;
					}
				})
				.catch(err => console.error(err));
		},

		/**
		 * Query API to get the page data (ON PAGE API) for a finished task
		 * @param {number} taskId - ID of a task
		 */
		getPages(taskId) {
			//console.log("getPages");
			this.$http
				.post(this.apiUrl + "dataforseo/task/pages", {
					taskId: taskId
				})
				.then(res => (this.explorationData = res.data.data.results[0]))
				.catch(err => console.error(err));
		},

		/**
		 * Query API to get the images of a website
		 * @param {number} taskId - ID of a task
		 */
		getImages(taskId) {
			//console.log("getImages");
			this.$http
				.post(this.apiUrl + "dataforseo/task/images", {
					taskId: taskId
				})
				.then(res => (this.explorationImageData = res.data.data.results[0]))
		}
	}
};
</script>

<style scoped>
.center {
  display: flex;
  justify-content: center;
}

.center_vertical {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.fill-row-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.filter_container {
  display: flex;
  justify-content: space-between;
}

.filter_card {
  width: 50%;
  margin-bottom: 0em !important;
}

.txt_align_right {
  text-align: right;
}

.txt_center {
  text-align: center;
}

.url_box {
  word-break: break-word;
}
</style>
